module.exports = __webpack_public_path__ + "img/horizontal-logo.03df1a8f.png";